import { createSelector } from 'reselect'
import * as dotProp from 'dot-prop-immutable'

import { actionTypes } from './actions'

const initialState = {
  data: null,
  loading: false,
  error: null
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {

    case actionTypes.fetch: {
      return dotProp.set(state, 'loading', true)
    }

    case actionTypes.fetchSuccess: {
      let newState = dotProp.set(state, 'loading', false)
      newState = dotProp.set(newState, 'error', null)
      return dotProp.set(newState, 'data', action.payload)
    }

    case actionTypes.fetchFail: {
      let newState = dotProp.set(state, 'loading', false)
      newState = dotProp.set(newState, 'data', null)
      return dotProp.set(newState, 'error', action.payload)
    }

    default: {
      return state
    }
  }
}

export const getProfile = createSelector(
  (state) => state.profile.data,
  profile => profile
)

export const getProfileLoading = createSelector(
  (state) => state.profile.loading,
  loading => loading
)

export const getProfileError = createSelector(
  (state) => state.profile.data,
  error => error
)



// WEBPACK FOOTER //
// ./src/features/Settings/profile/store/reducers.js